import type { Options, Product, ProductVariant } from '../types/product'
import { useEffect, useState } from 'react'

import { getFirstAvailableVariant, getVariantFromSelectedOptions } from '../utils/index.js'

export function useVariant({
  product,
  selectedOptions,
}: {
  product: Product
  selectedOptions: Options
}): ProductVariant {
  const [variant, setVariant] = useState(getFirstAvailableVariant(product))

  // 根据已选的 option 获取当前的 variant
  useEffect(() => {
    const v = getVariantFromSelectedOptions({ product, selectedOptions })
    if (v && v.id !== variant.id) {
      setVariant(v)
    }
  }, [selectedOptions, product.variants, variant, product])

  return variant
}
